import { render, staticRenderFns } from "./EventInstructions.vue?vue&type=template&id=5d9b3cdb"
import script from "./EventInstructions.js?vue&type=script&lang=js&external"
export * from "./EventInstructions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports